export const STATE_NAME = 'ppi';

export const FETCH_PPI = 'PPI_FETCH_PPI';
export const FETCH_PPI_DONE = 'PPI_FETCH_PPI_DONE';
export const FETCH_PPI_FAIL = 'PPI_FETCH_PPI_FAIL';
export const FETCH_MARKET_PPIS = 'PPI_FETCH_MARKET_PPI_PPI';
export const FETCH_MARKET_PPIS_DONE = 'PPI_FETCH_MARKET_PPI_DONE';
export const FETCH_MARKET_PPIS_FAIL = 'PPI_FETCH_MARKET_PPI_FAIL';
export const FETCH_MARKET_USED_PPIS = 'PPI_FETCH_MARKET_USED_PPI_PPI';
export const FETCH_MARKET_USED_PPIS_DONE = 'PPI_FETCH_MARKET_USED_PPI_DONE';
export const FETCH_MARKET_USED_PPIS_FAIL = 'PPI_FETCH_MARKET_USED_PPI_FAIL';

// DELETE_PPI, DELETE_PPI_DONE, DELETE_PPI_FAIL

export const DELETE_PPI = 'PPI_DELETE_PPI';
export const DELETE_PPI_DONE = 'PPI_DELETE_DONE';
export const DELETE_PPI_FAIL = 'PPI_DELETE_PPI_FAIL';

export const CREATE_PPI_VARIANT = 'CREATE_PPIS_VARIANT';
export const CREATE_PPI_VARIANT_DONE = 'CREATE_PPIS_VARIANT_DONE';
export const CREATE_PPI_VARIANT_FAIL = 'CREATE_PPIS_VARIANT_FAIL';

export const FETCH_PPIS = 'PPI_FETCH_PPIS';
export const FETCH_PPIS_DONE = 'PPI_FETCH_PPIS_DONE';
export const FETCH_PPIS_FAIL = 'PPI_FETCH_PPIS_FAIL';
export const FETCH_PPIS_GLOBAL = 'PPI_FETCH_PPIS_GLOBAL';
export const FETCH_PPIS_GLOBAL_DONE = 'PPI_FETCH_PPIS_GLOBAL_DONE';
export const FETCH_PPIS_GLOBAL_FAIL = 'PPI_FETCH_PPIS_GLOBAL_FAIL';
export const FETCH_GLOBAL_PPIS_WITH_ID = 'FETCH_GLOBAL_PPI_WITH_ID';
export const FETCH_GLOBAL_PPIS_WITH_ID_DONE = 'FETCH_GLOBAL_PPI_WITH_ID_DONE';
export const FETCH_GLOBAL_PPIS_WITH_ID_FAIL = 'FETCH_GLOBAL_PPI_WITH_ID_FAIL';
export const CREATE_PPI = 'PPI_CREATE_PPI';
export const CREATE_PPI_DONE = 'PPI_CREATE_PPI_DONE';
export const CREATE_PPI_FAIL = 'PPI_CREATE_PPI_FAIL';
export const SAVE_PPI = 'PPI_SAVE_PPI';
export const SAVE_PPI_DONE = 'PPI_SAVE_PPI_DONE';
export const SAVE_PPI_FAIL = 'PPI_SAVE_PPI_FAIL';
export const DISCARD_DRAFT_PPI = 'PPI_DISCARD_DRAFT_PPI';
export const DISCARD_DRAFT_PPI_DONE = 'PPI_DISCARD_DRAFT_PPI_DONE';
export const DISCARD_DRAFT_PPI_FAIL = 'PPI_DISCARD_DRAFT_PPI_FAIL';

export const PUBLISH_PPI = 'PPI_PUBLISH';
export const PUBLISH_PPI_DONE = 'PPI_PUBLISH_DONE';
export const PUBLISH_PPI_FAIL = 'PPI_PUBLISH_FAIL';
export const UNPUBLISH_PPI = 'PPI_UNPUBLISH';
export const UNPUBLISH_PPI_DONE = 'PPI_UNPUBLISH_DONE';
export const UNPUBLISH_PPI_FAIL = 'PPI_UNPUBLISH_FAIL';
export const MARKASUPTODATE_PPI = 'PPI_MARKASUPTODATE';
export const MARKASUPTODATE_PPI_DONE = 'PPI_MARKASUPTODATE_DONE';
export const MARKASUPTODATE_PPI_FAIL = 'PPI_MARKASUPTODATE_FAIL';
export const CREATE_DRAFT_PPI = 'PPI_CREATE_DRAFT';
export const CREATE_DRAFT_PPI_DONE = 'PPI_CREATE_DRAFT_DONE';
export const CREATE_DRAFT_PPI_FAIL = 'PPI_CREATE_DRAFT_FAIL';
export const IMPORT_IFOOD_UPDATE_PPI = 'IMPORT_IFOOD_UPDATE_PPI';
export const IMPORT_IFOOD_UPDATE_PPI_DONE = 'IMPORT_IFOOD_UPDATE_PPI_DONE';
export const IMPORT_IFOOD_UPDATE_PPI_FAIL = 'IMPORT_IFOOD_UPDATE_PPI_FAIL';
export const IMPORT_GLOBAL_UPDATE_PPI = 'IMPORT_GLOBAL_UPDATE_PPI';
export const IMPORT_GLOBAL_UPDATE_PPI_DONE = 'IMPORT_GLOBAL_UPDATE_PPI_DONE';
export const IMPORT_GLOBAL_UPDATE_PPI_FAIL = 'IMPORT_GLOBAL_UPDATE_PPI_FAIL';

export const States = {
  DRAFT: 'DRAFT',
  REVIEW: 'REVIEW',
  REJECTED: 'REJECTED',
  APPROVED: 'APPROVED',
  PUBLISHED: 'PUBLISHED',
  UNPUBLISHED: 'UNPUBLISHED',
  PUBLISHEDPPSIS: 'PUBLISHEDPPSIS'
};

export const EnrichmentData = {
  IN_PROGRESS: 'inProgressPPIEnrichmentData',
  PUBLISHED: 'publishedPPIEnrichmentData'
};

export const PREPARATION_TIME_UNIT_DEFAULT = '101';
export const SECOND_SHELF_LIFE_UNIT_DEFAULT = '101';
export const PRODUCTION_TIME_UNIT_DEFAULT = '100';
export const SERVING_HOLDING_TEMP_UNIT_DEFAULT = '100';
export const SERVING_HOLDING_TIME_UNIT_DEFAULT = '100';

// Action for fetching non-market specific global PPI:s. Used for NIR Markets
export const FETCH_PPIS_GLOBAL_NIR = 'FETCH_PPIS_GLOBAL_NIR';

export const PrepAndProdImageThumbnail = {
  Height: 220,
  Width: 220
};

// Fetch global PPi IFS Market for local market
export const FETCH_GLOBAL_PPI_IFS = 'FETCH_GLOBAL_PPI_IFS';
export const FETCH_GLOBAL_PPI_IFS_DONE = 'FETCH_GLOBAL_PPI_IFS_DONE';
export const FETCH_GLOBAL_PPI_IFS_FAIL = 'FETCH_GLOBAL_PPI_IFS_FAIL';

export const FETCH_NEW_PPI_AVAILABLE = 'FETCH_NEW_PPI_AVAILABLE';
export const FETCH_NEW_PPI_AVAILABLE_DONE = 'FETCH_NEW_PPI_AVAILABLEI_DONE';
export const FETCH_NEW_PPI_AVAILABLE_FAIL = 'FETCH_NEW_PPI_AVAILABLE_FAIL';
export const FETCH_PPIS_GLOBAL_UPDATE = 'FETCH_PPIS_GLOBAL_UPDATE';
export const FETCH_PPIS_GLOBAL_UPDATE_DONE = 'FETCH_PPIS_GLOBAL_UPDATE_DONE';
export const FETCH_PPIS_GLOBAL_UPDATE_FAIL = 'FETCH_PPIS_GLOBAL_UPDATE_FAIL';

export const FETCH_PPIS_UPDATE = 'FETCH_PPIS_UPDATE';
export const FETCH_PPIS_UPDATE_DONE = 'FETCH_PPIS_UPDATE_DONE';
export const FETCH_PPIS_UPDATE_FAIL = 'FETCH_PPIS_UPDATE_FAIL';

//Create ppi variant global
export const GLOBAL_VARIANT_DIALOG = 'GLOBAL_VARIANT_DIALOG';

export const FETCH_GLOBAL_PPI_VARIANT = 'FETCH_GLOBAL_PPI_VARIANT';
export const FETCH_GLOBAL_PPI_VARIANT_DONE = 'FETCH_GLOBAL_PPI_VARIANT_DONE';
export const FETCH_GLOBAL_PPI_VARIANT_FAIL = 'FETCH_GLOBAL_PPI_VARIANT_FAIL';

export const SET_PPI_ID = 'SET_PPI_ID';

export const FETCH_COPY_LOCAL_PPIS = 'FETCH_COPY_LOCAL_PPIS';
export const FETCH_COPY_LOCAL_PPIS_DONE = 'FETCH_COPY_LOCAL_PPIS_DONE';
export const FETCH_COPY_LOCAL_PPIS_FAIL = 'FETCH_COPY_LOCAL_PPIS_FAIL';

export const EMPTY_SINGLE_PPI = 'EMPTY_SINGLE_PPI';

